import { Document, FilePdf } from '@/assets/icons'
import { MimeType } from '@/constants/constants-mime-types'

type UserFileTypeIconProps = {
  detectedContentType: string | null | undefined
  className: string
}

function isPdfContentType(detectedContentType: string | null | undefined): boolean {
  return detectedContentType?.split(';')[0]?.trim().toLowerCase() === MimeType.PDF
}

export function UserFileTypeIcon({ detectedContentType, className }: UserFileTypeIconProps) {
  const Icon = isPdfContentType(detectedContentType) ? FilePdf : Document
  return <Icon className={className} aria-hidden />
}
